import templateUrl from "./employers-directory-manageIndustry-main.html";

import "./employers-directory-manageIndustry-main.scss"

export const employersDirectoryManageIndustryMainComponent = {
  templateUrl,
  bindings: {
    details: "<",
  },
  controller: class employersDirectoryManageIndustryMainComponent {
    constructor($state, $cookies, toastr, EmployersDirectoryService) {
      "ngInject";
      this.$state = $state;
      this.$cookies = $cookies;
      this.toastr = toastr;

      this.EmployersDirectoryService = EmployersDirectoryService;
    }
    $onInit() {
     
      this.id = 0
      this.industry_type= "";
      this.outlookTitle="";
      this.outlookDescription="";
      this.webinarTitle="";
      this.webinarLink="";
      this.description="";
      this.industryOverviewLink=null
      
      let industry = this.$cookies.get("industry");
      if(industry) {
        this.filterHandleEmployersDirectoryManageIndustryData(industry)
      }else{
        this.modifiedEmployersDirectoryManageIndustryData(this.details);
      }
    }

    modifiedEmployersDirectoryManageIndustryData(EmployersDirectoryManageIndustryData){
         this.id = EmployersDirectoryManageIndustryData[0].industryId
          this.industry_type = EmployersDirectoryManageIndustryData[0].displayName
          this.outlookTitle = EmployersDirectoryManageIndustryData[0].outlookTitle
          this.outlookDescription = EmployersDirectoryManageIndustryData[0].outlookDescription
          this.webinarTitle = EmployersDirectoryManageIndustryData[0].webinarTitle
          this.webinarLink = EmployersDirectoryManageIndustryData[0].webinarLink
          this.description = EmployersDirectoryManageIndustryData[0].description
          this.industryOverviewLink = EmployersDirectoryManageIndustryData[0].industryOverviewLink
    }

    
    handleradioBtn(value){
      this.$cookies.put("industry", value.displayName)
      this.industry_type = value
      this.filterHandleEmployersDirectoryManageIndustryData(value.displayName)
    }

    filterHandleEmployersDirectoryManageIndustryData(value) {
        this.details.map((item) =>{
           if(value === item.displayName) {
            this.id = item.industryId
            this.industry_type = item.displayName
            this.outlookTitle = item.outlookTitle
            this.outlookDescription = item.outlookDescription
            this.webinarTitle = item.webinarTitle
            this.webinarLink = item.webinarLink
            this.description = item.description
            this.industryOverviewLink = item.industryOverviewLink 
           }
        })
    }

    handleCancel() {
      this.$cookies.remove("industry");
      this.$state.go("directory");
    }

    handleGoBack() {
      this.handleCancel();
    }

    onSubmit() {
       const details = {
        displayName: this.industry_type,
        outlookTitle: this.outlookTitle,
        outlookDescription: this.outlookDescription,
        webinarTitle: this.webinarTitle,
        webinarLink: this.webinarLink,
        description: this.description,
        industryOverviewLink: this.industryOverviewLink ? this.industryOverviewLink : null
       }
       console.log(details)
       this.EmployersDirectoryService.updateIndustriesById(details, this.id)
       .then((_) =>{
          this.toastr.success("Industry updated successfully");
          this.$state.reload()
       })
       .catch((error) =>{
        this.toastr.error(error.data.errors.message);
       })
    }

  },
};


// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory-manageIndustry-main/employers-directory-manageIndustry-main.component.js